import { render, staticRenderFns } from "./assignCustomPlanner.vue?vue&type=template&id=19ca7d97"
import script from "./assignCustomPlanner.vue?vue&type=script&lang=js"
export * from "./assignCustomPlanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports